document.addEventListener('DOMContentLoaded', () => {

  function hideGroupedSlides(sliderEl) {
    const swiper = sliderEl.swiper;
    if (!swiper) return;

    swiper.slides.forEach(slide => {
      if (!slide.classList.contains("main-product")) {
        slide.style.display = "none";
      }
    });

    swiper.update();
    swiper.slideTo(0, 0);
  }

  const initSlider = (el) => {
    if (el.dataset.initialized === 'true') return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (el.offsetWidth === 0) return;

        el.dataset.initialized = 'true';

        new Swiper(el, {
          slidesPerView: 1,
          loop: false,
          resistanceRatio: 0.85,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          on: {
            init(swiper) {
              hideGroupedSlides(swiper.el);
            }
          }
        });
      });
    });
  };

  const sliders = document.querySelectorAll('.product-item__image-slider');

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const slider = entry.target;

        if (slider.offsetWidth > 0) {
          initSlider(slider);
          io.unobserve(slider);
        }
      }
    });
  }, {
    rootMargin: '200px',
  });

  sliders.forEach((slider) => io.observe(slider));
});


document.addEventListener('DOMContentLoaded', () => {
  const startTeaser = () => {
    const teaserSliderEl = document.querySelector('.product-item--teaser .product-item__image-slider');
    if (!teaserSliderEl) return;

    if (teaserSliderEl.closest("product-item")?.dataset.teaserDisabled === "true") {
      return;
    }

    if (!teaserSliderEl.swiper) {
      setTimeout(startTeaser, 500);
      return;
    }

    const swiper = teaserSliderEl.swiper;
    let teaserKilled = false;

    ['click', 'pointerdown'].forEach(evt => {
      teaserSliderEl.addEventListener(evt, () => {
        teaserKilled = true;
        teaserSliderEl.closest("product-item").dataset.teaserDisabled = "true"; // mark as dead
      }, { once: true });
    });

    const animate = () => {

      if (teaserKilled || teaserSliderEl.closest("product-item")?.dataset.teaserDisabled === "true") {
        return;
      }

      const wrapper = swiper.wrapperEl;
      wrapper.style.transition = "transform 450ms ease";
      swiper.setTranslate(-swiper.width * 0.28);

      setTimeout(() => {
        if (teaserKilled || teaserSliderEl.closest("product-item")?.dataset.teaserDisabled === "true") {
          return;
        }

        swiper.slideTo(0, 450);

        setTimeout(animate, 2000);
      }, 1400);
    };

    setTimeout(animate, 500);
  };

  startTeaser();
});



window.addEventListener("resize", () => {
  if (window.innerWidth > 768) {
    document.querySelectorAll(".product-item--teaser .swiper-wrapper").forEach(w => {
      w.style.transition = "none";
      w.style.transform = "translate3d(0,0,0)";
    });
  }
});